export function insertEmojiAtSelection(text, emoji, start = text.length, end = start) {
  const from = Math.max(0, Math.min(start, text.length))
  const to = Math.max(from, Math.min(end, text.length))
  return { text: text.slice(0, from) + emoji + text.slice(to), cursor: from + emoji.length }
}
